import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Container, Sprite } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import { isMobile } from '../../../core/helpers/isMobile';
import { Spine } from '../../../core/classes/spine';
import { loadingStore } from '../../../store/loadingStore';
import { PixiAssets } from '../../../core/helpers/loadResources';
import { initialResourceMobile } from '../../../core/resources';

const LoadingContent = observer(() => {
  const { progress } = loadingStore;
  const [spine, setSpine] = useState(null);
  const loadingSpineRef = useRef();

  const loadingBackground = useMemo(() => {
    return PixiAssets.get(initialResourceMobile.loadingBackground.name);
  }, []);

  useEffect(() => {
    const loadingSpine = new Spine({ key: 'loading' });
    loadingSpine.play('animation', true);
    if (isMobile()) {
      loadingSpine.scale.set(Math.min(window.innerWidth / 540, window.innerHeight / 960));
    }
    loadingSpineRef.current.x = isMobile() ? window.innerWidth / 2 : 720;
    loadingSpineRef.current.y = isMobile() ? window.innerHeight / 2 : 405;
    setSpine(loadingSpine);
    loadingSpineRef.current.addChild(loadingSpine);
  }, []);

  const progressBone = useMemo(() => {
    return spine && spine.skeleton.findBone('progress');
  }, [spine]);

  useEffect(() => {
    if (progressBone) progressBone.scaleX = progress * 0.01;
  }, [progress, progressBone]);

  return (
    <Container>
      {isMobile() && (
        <Sprite texture={loadingBackground} width={window.innerWidth} height={window.innerHeight} />
      )}
      <Container ref={loadingSpineRef} />
    </Container>
  );
});
export default LoadingContent;
